(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after-dev"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sections = document.querySelectorAll('.ba[data-ba-section]');
  for (var s = 0; s < sections.length; s++) {
    (function(section) {
      var slides = section.querySelectorAll('[data-ba-slide]');
      var thumbs = section.querySelectorAll('[data-ba-thumb]');
      var prevBtn = section.querySelector('[data-ba-prev]');
      var nextBtn = section.querySelector('[data-ba-next]');
      if (slides.length < 2) return;

      var current = 0;
      var total = slides.length;
      var timer = null;

      function goTo(idx) {
        if (idx < 0) idx = total - 1;
        if (idx >= total) idx = 0;
        slides[current].classList.remove('ba__slide--active');
        if (thumbs[current]) thumbs[current].classList.remove('ba__thumb--active');
        current = idx;
        slides[current].classList.add('ba__slide--active');
        if (thumbs[current]) thumbs[current].classList.add('ba__thumb--active');
        for (var i = 0; i < thumbs.length; i++) {
          var c = thumbs[i].querySelector('circle');
          if (c) { c.style.animation = 'none'; c.offsetHeight; c.style.animation = ''; }
        }
        restartTimer();
      }

      function restartTimer() {
        clearInterval(timer);
        timer = setInterval(function() { goTo(current + 1); }, 6000);
      }

      for (var t = 0; t < thumbs.length; t++) {
        (function(i) { thumbs[i].addEventListener('click', function() { goTo(i); }); })(t);
      }

      if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); });

      var touchX = 0;
      section.addEventListener('touchstart', function(e) { touchX = e.changedTouches[0].screenX; }, { passive: true });
      section.addEventListener('touchend', function(e) {
        var d = touchX - e.changedTouches[0].screenX;
        if (Math.abs(d) > 50) goTo(d > 0 ? current + 1 : current - 1);
      }, { passive: true });

      restartTimer();
    })(sections[s]);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.isTransparent = document.querySelector('.header-wrapper').classList.contains('transparent-header');

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (this.isTransparent) {
        if (scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          this.header.classList.remove('transparent-header');
          if (scrollTop > this.currentScrollTop) {
            this.header.classList.add('shopify-section-header-hidden');
          } else {
            this.header.classList.remove('shopify-section-header-hidden');
          }
        } else {
          this.header.classList.remove('scrolled-past-header', 'shopify-section-header-hidden');
          this.header.classList.add('transparent-header');
        }
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close()); 
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class luminLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lumin-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        setTimeout(() => {
          tooltip.classList.remove('show')
          tooltip.classList.add('hiding')
          setTimeout(() => {
            tooltip.classList.remove('hiding')
          }, 200)
        }, 100)
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', luminLookBook)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["selling-fast"] && !Shopify.designMode) return;
  try {
    
(function () {
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function init(root) {
    if (root.dataset.sfReady) return;
    root.dataset.sfReady = '1';
    var minutes = parseInt(root.dataset.minutes, 10) || 53;
    var timerEl = root.querySelector('[data-sf-timer]');
    var key = 'strider_sf_end_' + minutes;
    var end;
    try { end = parseInt(localStorage.getItem(key), 10); } catch (e) {}
    var now = Date.now();
    if (!end || end < now) { end = now + minutes * 60000; try { localStorage.setItem(key, end); } catch (e) {} }

    function tick() {
      var diff = Math.max(0, Math.floor((end - Date.now()) / 1000));
      var m = Math.floor(diff / 60), s = diff % 60;
      if (timerEl) timerEl.textContent = pad(m) + ':' + pad(s);
      if (diff <= 0) {
        end = Date.now() + minutes * 60000;
        try { localStorage.setItem(key, end); } catch (e) {}
      }
    }
    tick();
    setInterval(tick, 1000);

    var toggle = root.querySelector('[data-sf-toggle]');
    var detail = root.querySelector('[data-sf-detail]');
    if (toggle && detail) {
      toggle.addEventListener('click', function () {
        var open = detail.hasAttribute('hidden');
        if (open) { detail.removeAttribute('hidden'); toggle.setAttribute('aria-expanded', 'true'); }
        else { detail.setAttribute('hidden', ''); toggle.setAttribute('aria-expanded', 'false'); }
      });
    }
  }
  function boot() { document.querySelectorAll('[data-sellingfast]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-quiz"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.sqReady) return;
    root.dataset.sqReady = '1';

    var ACCENT = root.style.getPropertyValue('--sq-accent');
    var sizes = [];
    try { sizes = JSON.parse(root.dataset.sizes || '[]'); } catch (e) { sizes = []; }
    var menOffset = parseFloat(root.dataset.menOffset || '1.5');

    // Build buckets from the product's real Size option values.
    var buckets = sizes.map(function (label) {
      var us = (label.match(/US\/CA\s*([0-9.]+)/) || [])[1];
      var eu = (label.match(/EU\s*([0-9.]+)/) || [])[1];
      return { label: label, us: parseFloat(us), eu: eu || '' };
    }).filter(function (b) { return !isNaN(b.us); });

    var modal = root.querySelector('[data-sq-modal]');
    var body = root.querySelector('[data-sq-body]');
    var prog = root.querySelector('[data-sq-progress]');
    var back = root.querySelector('[data-sq-back]');

    var STEPS = [
      { key: 'brand', q: 'Which brand do you usually wear?', hint: 'So we can match your current fit.',
        opts: ['Nike','Adidas','New Balance','Skechers','Vans','Converse','Puma','Reebok','Other'].map(function(b){return {label:b,value:b};}) },
      { key: 'size', q: 'What size do you take in that brand?', hint: 'Pick your most common size.', sizePicker: true },
      { key: 'fit', q: 'How do those usually fit?', hint: 'Think about a full day of wear.',
        opts: [ {label:'Too snug', sub:'Toes feel cramped', value:'tight'}, {label:'Just right', sub:'Comfortable all day', value:'perfect'}, {label:'Too roomy', sub:'Foot slides around', value:'loose'} ] },
      { key: 'width', q: 'How would you describe your feet?', hint: 'Choose the closest match.',
        opts: [ {label:'Narrow', sub:'Often need narrow sizes', value:'narrow'}, {label:'Regular', sub:'Most shoes fit', value:'regular'}, {label:'Wide', sub:'Need room in the toe box', value:'wide'}, {label:'Extra wide', sub:'Usually size up for width', value:'xwide'} ] },
      { key: 'toe', q: 'How much toe room do you like?', hint: 'More room = more natural movement.',
        opts: [ {label:'Snug', sub:'Like athletic shoes', value:'snug'}, {label:'Natural', sub:'Comfortable wiggle room', value:'natural'}, {label:'Roomy', sub:'Maximum toe freedom', value:'roomy'} ] },
      { key: 'cond', q: 'Anything we should know about your feet?', hint: 'Select all that apply.', multi: true,
        opts: [ {label:'Bunions', value:'bunions'}, {label:'Flat feet', value:'flat'}, {label:'High arches', value:'arch'}, {label:'Plantar fasciitis', value:'pf'}, {label:'Wide forefoot', value:'forefoot'}, {label:'None', value:'none'} ] },
      { key: 'use', q: 'Where will you wear them most?', hint: 'Last one!',
        opts: [ {label:'Everyday walking', value:'daily'}, {label:'On your feet all day', value:'work'}, {label:'Casual / errands', value:'casual'}, {label:'Outdoors', value:'outdoor'}, {label:'Workouts', value:'gym'} ] }
    ];

    var state = { step: 0, gender: 'women', size: null, answers: {}, cond: [] };

    function open() { modal.hidden = false; document.body.style.overflow = 'hidden'; state.step = 0; render(); }
    function close() { modal.hidden = true; document.body.style.overflow = ''; }

    function renderProgress() {
      prog.innerHTML = '';
      for (var i = 0; i < STEPS.length; i++) {
        var d = document.createElement('span');
        d.className = 'sq-dot' + (i <= state.step ? ' is-on' : '');
        prog.appendChild(d);
      }
    }

    function render() {
      renderProgress();
      back.hidden = state.step === 0;
      if (state.step >= STEPS.length) { renderResult(); return; }
      var s = STEPS[state.step];
      var html = '<p class="sq-q">' + s.q + '</p><p class="sq-hint">' + s.hint + '</p>';

      if (s.sizePicker) {
        html += '<div class="sq-toggle"><button data-g="women" class="' + (state.gender==='women'?'is-on':'') + '">Women</button><button data-g="men" class="' + (state.gender==='men'?'is-on':'') + '">Men</button></div>';
        html += '<div class="sq-opts cols">';
        ['5','5.5','6','6.5','7','7.5','8','8.5','9','9.5','10','10.5','11','11.5','12'].forEach(function (n) {
          html += '<button class="sq-opt center" data-size="' + n + '">' + n + '</button>';
        });
        html += '</div>';
      } else {
        html += '<div class="sq-opts">';
        s.opts.forEach(function (o) {
          var sel = s.multi && state.cond.indexOf(o.value) > -1 ? ' is-sel' : '';
          html += '<button class="sq-opt' + sel + '" data-val="' + o.value + '"><b>' + o.label + '</b>' + (o.sub ? '<small>' + o.sub + '</small>' : '') + '</button>';
        });
        html += '</div>';
        if (s.multi) html += '<button class="sq-proceed" data-proceed>Continue</button>';
      }
      body.innerHTML = html;
      bindStep(s);
    }

    function next() { state.step++; render(); }

    function bindStep(s) {
      if (s.sizePicker) {
        body.querySelectorAll('[data-g]').forEach(function (b) {
          b.addEventListener('click', function () { state.gender = b.dataset.g; render(); });
        });
        body.querySelectorAll('[data-size]').forEach(function (b) {
          b.addEventListener('click', function () { state.size = parseFloat(b.dataset.size); next(); });
        });
        return;
      }
      body.querySelectorAll('[data-val]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (s.multi) {
            var v = b.dataset.val;
            if (v === 'none') { state.cond = ['none']; }
            else { state.cond = state.cond.filter(function (x) { return x !== 'none'; });
              var i = state.cond.indexOf(v); if (i > -1) state.cond.splice(i,1); else state.cond.push(v); }
            render();
          } else { state.answers[s.key] = b.dataset.val; next(); }
        });
      });
      var pr = body.querySelector('[data-proceed]');
      if (pr) pr.addEventListener('click', function () { if (!state.cond.length) state.cond = ['none']; next(); });
    }

    function recommend() {
      var base = state.size || 8;
      if (state.gender === 'men') base += menOffset;
      var adj = 0;
      if (state.answers.fit === 'tight') adj += 0.5;
      if (state.answers.fit === 'loose') adj -= 0.5;
      if (state.answers.width === 'wide') adj += 0.5;
      if (state.answers.width === 'xwide') adj += 1;
      if (state.answers.toe === 'roomy') adj += 0.5;
      if (state.cond.indexOf('bunions') > -1 || state.cond.indexOf('forefoot') > -1) adj += 0.5;
      var target = base + adj;
      var best = buckets[0], bd = 99;
      buckets.forEach(function (bk) { var d = Math.abs(bk.us - target); if (d < bd) { bd = d; best = bk; } });
      var conf = 96 - Math.min(8, Math.round(bd * 4) + Math.abs(adj) * 2);
      return { bucket: best, conf: Math.max(85, conf) };
    }

    function renderResult() {
      renderProgress();
      back.hidden = true;
      var r = recommend();
      var b = r.bucket;
      var d = root.dataset;
      var html = '' +
        '<div class="sq-badge" aria-hidden="true">&#9733;</div>' +
        '<p class="sq-res-head">Your perfect fit</p>' +
        '<p class="sq-res-sub">Based on your foot profile</p>' +
        '<div class="sq-res-card">' +
          '<p class="sq-res-label">WE RECOMMEND</p>' +
          '<div class="sq-res-size">' + b.label.split('·')[0].trim() + '</div>' +
          '<div class="sq-res-eu">' + b.label + '</div>' +
          '<span class="sq-pill">' + r.conf + '% match confidence</span>' +
        '</div>' +
        '<div class="sq-stats">' +
          '<div class="sq-stat"><b>' + d.stat1n + '</b><span>' + d.stat1l + '</span></div>' +
          '<div class="sq-stat"><b>' + d.stat2n + '</b><span>' + d.stat2l + '</span></div>' +
          '<div class="sq-stat"><b>' + d.stat3n + '</b><span>' + d.stat3l + '</span></div>' +
        '</div>' +
        '<button class="sq-cta" data-pick>Select ' + b.label.split('·')[0].trim() + ' &#8594;</button>' +
        '<button class="sq-retake" data-retake>Retake quiz</button>';
      body.innerHTML = html;

      body.querySelector('[data-retake]').addEventListener('click', function () { state = { step: 0, gender: 'women', size: null, answers: {}, cond: [] }; render(); });
      body.querySelector('[data-pick]').addEventListener('click', function () {
        applySize(b);
        close();
      });
    }

    // Expose the recommendation so the buy box / bundle app can pick it up.
    function applySize(b) {
      try { localStorage.setItem('strider_recommended_size', b.label); } catch (e) {}
      window.dispatchEvent(new CustomEvent('strider:size-recommended', { detail: { label: b.label, us: b.us, eu: b.eu } }));
      // Best-effort: set any native <select> on the page that contains this label.
      document.querySelectorAll('select').forEach(function (sel) {
        for (var i = 0; i < sel.options.length; i++) {
          if (sel.options[i].text.trim() === b.label) { sel.value = sel.options[i].value; sel.dispatchEvent(new Event('change', { bubbles: true })); break; }
        }
      });
      var bx = document.querySelector('[data-sq-scroll], .product-form, product-info');
      if (bx) bx.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    root.querySelectorAll('[data-sq-open]').forEach(function (b) { b.addEventListener('click', open); });
    root.querySelectorAll('[data-sq-close]').forEach(function (b) { b.addEventListener('click', close); });
    back.addEventListener('click', function () { if (state.step > 0) { state.step--; render(); } });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
  }

  function boot() { document.querySelectorAll('[data-sizequiz]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-gallery"] && !Shopify.designMode) return;
  try {
    

class VideoGallery extends HTMLElement {
  constructor() {
    super();
    this.deferredMedia = this.querySelector(".video-gallery__media");
    this.videoPlaylist = this.querySelector(".video-gallery__thumbnails");
    this.activeVideoTitle = this.querySelector(".video-gallery__active-video-title");
    this.videoPlayer = null;

    this.handleVideoClick = this.handleVideoClick.bind(this);
  }

  connectedCallback() {
    this.videoPlaylist.addEventListener("click", this.handleVideoClick);
  }

  disconnectedCallback() {
    this.videoPlaylist.removeEventListener("click", this.handleVideoClick);
  }

  getVideoEmbedRef = () => {
    return document.querySelector('.video-gallery__embed');
  }

  getVideoPlayerRef = () => {
    return document.querySelector('.video-gallery__player');
  }

  clearExistingMedia = (type) => {
    
    const existingEmbed = this.getVideoEmbedRef();
    const existingPlayer = this.getVideoPlayerRef();

    if (type === 'video' && existingEmbed) {
      existingEmbed.remove();
    }

    if (type === 'embed' && existingPlayer) {
      existingPlayer.remove();
    }
  }

  handleVideoClick = (e) => {

    const thumbnailElement = event.target.closest(".video-gallery__thumbnail");
    if (!thumbnailElement) {
      console.error('Thumbnail element not found');
      return;
    }
    
    if (this.deferredMedia) {
      this.deferredMedia.loadContent(false);
    }

    const videoURL = thumbnailElement.dataset.videoUrl;
    const embedType = thumbnailElement.dataset.embedUrlType;
    const embedID = thumbnailElement.dataset.embedUrlId;
    const videoTitle = thumbnailElement.dataset.videoTitle;
    
    if (videoURL) {
        // Load video
        this.loadVideo(videoURL, videoTitle);
    } else if (embedType && embedID) {
        // Load embed
        this.loadEmbed(embedType, embedID, videoTitle);
    } else {
        console.error('Video URL or embed URL not found');
    }

    this.scrollToVideoPlayer(); 
  }

  // Function to scroll to the video player
  scrollToVideoPlayer = () => {
    if (!this.videoPlayer) {
      console.error('Video player element not found');
      return;
    }

    const videoPlayerPosition = this.videoPlayer.getBoundingClientRect().top + window.scrollY - 150;

    window.scrollTo({
      top: videoPlayerPosition,
      behavior: 'smooth'
    });
  }

  loadVideo = (videoURL, videoTitle) => {

    this.clearExistingMedia('video');

    // Get the video player
    this.videoPlayer = this.getVideoPlayerRef();

    if (!this.videoPlayer) {
      console.log('Video player element not found, creating it');
      this.videoPlayer = document.createElement('video');
      this.videoPlayer.classList.add('video-gallery__player');
      this.videoPlayer.setAttribute('playsinline', '');
      this.videoPlayer.setAttribute('autoplay', '');
      this.videoPlayer.setAttribute('controls', '');

      this.deferredMedia.appendChild(this.videoPlayer);
    }
    
    // Set video source and title
    this.videoPlayer.src = videoURL;
    this.videoPlayer.load();

    // Play the video
    this.videoPlayer.addEventListener('loadedmetadata', function loadedMetadataHandler() {
      this.videoPlayer.play()
        .then(() => {
          console.log('Video started playing');
          // Remove the event listener after playback starts
          this.videoPlayer.removeEventListener('loadedmetadata', loadedMetadataHandler);
        })
        .catch((error) => {
          console.error('Error playing video:', error);
        });
    }.bind(this));

    // Update the active video title
    this.activeVideoTitle.innerText = videoTitle;
  }

  loadEmbed = (embedType, embedID, videoTitle) => {

    if (embedType !== 'youtube' && embedType !== 'vimeo') {
      console.error('Invalid embed type');
      return;
    }

    this.clearExistingMedia('embed');

    const embedURL = (embedType == 'youtube') ? `https://www.youtube.com/embed/${embedID}?autoplay=1`: `https://player.vimeo.com/video/${videoId}?autoplay=1`;

    let embedElement = this.getVideoEmbedRef();

    if (!embedElement) {
      embedElement = document.createElement('iframe');
      embedElement.classList.add('video-gallery__embed');
      embedElement.setAttribute('allow', 'autoplay; encrypted-media');
      embedElement.setAttribute('allowfullscreen', '');
      this.deferredMedia.appendChild(embedElement);
    }
    
    embedElement.src = embedURL;
    embedElement.setAttribute('title', videoTitle);

    this.videoPlayer = embedElement;

    this.activeVideoTitle.innerText = videoTitle;
  }

}

customElements.define('video-gallery', VideoGallery);


  } catch(e) { console.error(e); }
})();
})();
